var map = {
	"./IMG_0836.JPG": 329,
	"./IMG_0837.JPG": 4316,
	"./IMG_0838.JPG": 6145,
	"./IMG_0839.JPG": 4778,
	"./IMG_0840.JPG": 255,
	"./IMG_0841.JPG": 8901,
	"./IMG_0842.JPG": 37,
	"./IMG_0843.JPG": 1284,
	"./IMG_0844.JPG": 1599,
	"./IMG_0845.JPG": 7345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4154;